import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-tryher-timeline.js';

const timelineItem = ({ title, content }, index) => `
  <article
    data-attribute="tryher-timeline__item"
    data-position="${index % 2 ? 'left' : 'right'}"
    class="tryher-timeline__item"
  >
    <div data-attribute="tryher-timeline__label" class="tryher-timeline__label">
      ${title}
    </div>
    <div class="tryher-timeline__marker" aria-hidden="true"></div>
    <div data-attribute="tryher-timeline__card" class="tryher-timeline__card">
      ${content}
    </div>
  </article>
`;

const items = [
  {
    title: '<h2><strong>Days 1-7</strong></h2><p>First Thing You Notice</p>',
    content:
      "<p>Your skin looks more hydrated and smoother almost right away. Under-eyes don't feel as dry or crepey, and makeup sits better instead of creasing. Nothing dramatic yet, it just looks healthier and more refreshed.</p>",
  },
  {
    title: '<h2><strong>Days 8-14</strong></h2><p>You Start Seeing It</p>',
    content:
      "<p>Under-eyes begin to look less hollow and lines around your mouth and eyes soften a bit. Your face looks less tired overall. This is when most people realize it's actually doing something.</p>",
  },
  {
    title: '<h2><strong>Days 14-21</strong></h2><p>People Start Noticing Too</p>',
    content:
      "<p>Your skin looks a bit fuller and more even. Fine lines are less noticeable and you start getting “rested” comments without really changing anything else. You don't look different, just better.</p>",
  },
  {
    title: '<h2><strong>Days 14-30</strong></h2>',
    content:
      "<h2><strong>Where It Really Shows</strong></h2><p>Deeper lines start looking softer and under-eyes don't appear as sunken. Your skin has a smoother, healthier glow overall. This is usually when people say they rely less on makeup.</p>",
  },
];

const contentHtml = `
  <div
    data-attribute="tryher-timeline"
    class="tryher-timeline container"
    data-card-background-color="#FFF7FC"
    data-card-text-color="#1F1F1F"
    data-card-border-color="#1F1F1F"
    data-line-color="#f96da3"
    data-line-border-color="#1F1F1F"
    style="
      --card-background-color: #fff7fc;
      --card-text-color: #1f1f1f;
      --card-border-color: #1f1f1f;
      --line-color: #f96da3;
      --line-border-color: #1f1f1f;
    "
  >
    <header
      data-attribute="tryher-timeline__header"
      class="tryher-timeline__header"
    >
      <h2 style="text-align: center">
        <strong>What People Actually Notice After Using It Daily</strong>
      </h2>
      <p style="text-align: center">
        Based on real results from women dealing with lines, hollow under-eyes,
        and tired-looking skin
      </p>
    </header>
    <div data-attribute="tryher-timeline__list" class="tryher-timeline__list">
      ${items.map(timelineItem).join('')}
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, { backgroundColor: '#FFFFFF', textColor: '#1F1F1F' });
